import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { AbstractControl, FormControl, ValidationErrors } from "@angular/forms";
import { Subscription } from "rxjs";

@Component({
  selector: 'dr-customer-offers-ui-hour-minute-picker',
  templateUrl: './hour-minute-picker.component.html',
  styleUrls: ['./hour-minute-picker.component.scss'],
})
export class HourMinutePickerComponent implements OnInit, OnDestroy {

  @Input() hourFormControl: FormControl<string> = new FormControl('1', {nonNullable: true});
  @Input() minuteFormControl: FormControl<string> = new FormControl('00', {nonNullable: true});
  @Input() periodFormControl: FormControl<'am' | 'pm'> = new FormControl('am', {nonNullable: true});
  @Input() minuteFrequency: number = 30;

  protected invalidForm: boolean = false;
  protected get hourErrors() {
    const hasErrors = this.hourFormControl?.errors?.['hour'];
    if (!hasErrors) return '';
    return `COM.ERRORS.BULK_SELECTION.${hasErrors}`
  };

  private subscription?: Subscription;

  constructor() {}

  ngOnInit(): void {
    // this.subscription = this.hourFormControl.valueChanges.subscribe(hour => this.checkInputHour(hour));
    this.hourFormControl.addValidators(this.hourValidity);
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  protected decrementHour(): void {
    // Decrement the hours by 1 and update the converted time
    if (+this.hourFormControl.value > 1) {
      this.hourFormControl.setValue((+this.hourFormControl.value - 1).toString());
    } else {
      this.hourFormControl.setValue('12');
    }
  }
  
  protected decrementMinuteByFrequency(): void {
    const minMinute = 0;
    let newMinute = 0;

    newMinute = +this.minuteFormControl.value - this.minuteFrequency;
    if (newMinute >= minMinute) {
      this.minuteFormControl.setValue(newMinute.toString());
    } else {
      // Handle the case where the new minute goes below 0
      const overload = 60 - (+this.minuteFrequency)
      this.minuteFormControl.setValue(overload.toString());
    }
  }

  protected incrementHour(): void {
    // Increment the hours by 1 and update the converted time
    const hourValue = +this.hourFormControl.value
    if (hourValue < 12) {
      this.hourFormControl.setValue((hourValue + 1).toString());
    } else {
      this.hourFormControl.setValue('1');
    }
  }

  protected incrementMinuteByFrequency(): void {
    const maxMinute = 59;
    let newMinute = 0;
    const minuteValue = this.minuteFormControl.value;
    
    if (minuteValue === null) {
      this.minuteFormControl.setValue('00');
      return;
    }

    newMinute = +minuteValue + this.minuteFrequency;

    if (newMinute <= maxMinute) {
      this.minuteFormControl.setValue(newMinute.toString());
    } else {
      // Handle the case where the new minute exceeds 59
      this.minuteFormControl.setValue('00');
    }
  }

  private hourValidity(control: AbstractControl): ValidationErrors | null {
    const hourValue = control.value as FormControl<string>;
    if (!hourValue || +hourValue < 1 || +hourValue > 12) {
      return {hour: 'INVALID_HOUR'}
    }
    return null;
  }
}